import { render } from "./BrandForefront.vue?vue&type=template&id=5450b98a&scoped=true"
import script from "./BrandForefront.vue?vue&type=script&lang=js"
export * from "./BrandForefront.vue?vue&type=script&lang=js"

import "./BrandForefront.vue?vue&type=style&index=0&id=5450b98a&scoped=true&lang=css"

import exportComponent from "G:\\BWD\\BWD-NEW-05-04-2024\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5450b98a"]])

export default __exports__